export type ExportType = 'xlsx' | 'xls' | 'csv';

export const MIME_TYPES: Record<ExportType, string> = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
  csv: 'text/csv',
};
